import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';

@Component({
  selector: 'dl-email-delivery-details',
  templateUrl: './email-delivery-details.component.html',
  styleUrls: ['./email-delivery-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmailDeliveryDetailsComponent implements OnInit {

  dataFetch: any;
  emailResponse: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public emailData: any,
    public qnsbnService: QnSbnService,
    public dialogRef: MatDialogRef<EmailDeliveryDetailsComponent>,
    private readonly oneSnackBar: OneSnackBarService,
  ){}

  ngOnInit(): void {
    this.qnsbnService.emailReportDetails(this.emailData).subscribe(
      res => {
        this.dataFetch = res;
        this.emailResponse = this.dataFetch.emailResponseData
      },
      err => {
        this.oneSnackBar.open('Please try again later', OneSnackBarType.ERROR, '', { duration: 3000 });
      }
    )
  }

  close() {
    console.log('Close button clicked');
    this.dialogRef.close();
  }

}
